import { render, staticRenderFns } from "./AuthorhistAutocomplete.vue?vue&type=template&id=665afdb7&"
import script from "./AuthorhistAutocomplete.vue?vue&type=script&lang=js&"
export * from "./AuthorhistAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports